import React, { useState } from 'react';
import { SearchIcon, PlusIcon, EditIcon, TrashIcon, DownloadIcon, ExternalLinkIcon } from 'lucide-react';
export const InputSystemsManager: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingAssessment, setEditingAssessment] = useState<any>(null);
  const assessments = [{
    id: 'astrology',
    name: 'Astrological Chart',
    category: 'Inborn',
    type: 'Date/Time/Location Input',
    status: 'Active',
    apiSource: 'AstroAPI',
    xpValue: 250,
    lastUpdated: '2023-06-15'
  }, {
    id: 'dmit',
    name: 'DMIT Analysis',
    category: 'Inborn',
    type: 'Image Upload',
    status: 'Active',
    apiSource: 'BiometricAPI',
    xpValue: 200,
    lastUpdated: '2023-05-22'
  }, {
    id: 'numerology',
    name: 'Numerology',
    category: 'Inborn',
    type: 'Text Input',
    status: 'Active',
    apiSource: 'NumerologyCalc',
    xpValue: 150,
    lastUpdated: '2023-06-10'
  }, {
    id: 'mbti',
    name: 'MBTI Assessment',
    category: 'Self-Reported',
    type: 'Quiz',
    status: 'Active',
    apiSource: 'Internal',
    xpValue: 150,
    lastUpdated: '2023-06-18'
  }, {
    id: 'big5',
    name: 'Big Five Personality',
    category: 'Self-Reported',
    type: 'Quiz',
    status: 'Active',
    apiSource: 'PersonalityAPI',
    xpValue: 200,
    lastUpdated: '2023-06-02'
  }, {
    id: 'holland',
    name: 'Holland Code',
    category: 'Self-Reported',
    type: 'Quiz',
    status: 'Active',
    apiSource: 'Internal',
    xpValue: 175,
    lastUpdated: '2023-05-30'
  }, {
    id: 'family',
    name: 'Family Background',
    category: 'Context',
    type: 'Multiple Choice',
    status: 'Active',
    apiSource: 'Internal',
    xpValue: 100,
    lastUpdated: '2023-06-08'
  }, {
    id: 'education',
    name: 'Educational History',
    category: 'Context',
    type: 'Form Input',
    status: 'Active',
    apiSource: 'Internal',
    xpValue: 100,
    lastUpdated: '2023-06-05'
  }, {
    id: 'geography',
    name: 'Geographic Context',
    category: 'Context',
    type: 'Map Selection',
    status: 'Inactive',
    apiSource: 'GeoAPI',
    xpValue: 75,
    lastUpdated: '2023-05-15'
  }];
  const filteredAssessments = assessments.filter(assessment => {
    return assessment.name.toLowerCase().includes(searchTerm.toLowerCase()) && (filterCategory === '' || assessment.category === filterCategory);
  });
  const handleEditAssessment = (assessment: any) => {
    setEditingAssessment({
      ...assessment
    });
    setIsModalOpen(true);
  };
  const handleSaveAssessment = () => {
    // In a real app, this would update the assessment in the database
    setIsModalOpen(false);
    setEditingAssessment(null);
  };
  return <div data-id="element-276">
      <div className="mb-6" data-id="element-277">
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-278">
          Input Systems Manager
        </h1>
        <p className="text-gray-600" data-id="element-279">
          Configure and manage all assessment inputs used in the CareerAstro
          platform
        </p>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-280">
        <div className="p-6 border-b border-gray-200" data-id="element-281">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0" data-id="element-282">
            <div className="flex items-center space-x-4" data-id="element-283">
              <div className="relative" data-id="element-284">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-285">
                  <SearchIcon size={16} className="text-gray-400" data-id="element-286" />
                </div>
                <input type="text" placeholder="Search assessments..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#7D56F4] focus:border-[#7D56F4] w-full sm:w-64" data-id="element-287" />
              </div>
              <select value={filterCategory} onChange={e => setFilterCategory(e.target.value)} className="border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-288">
                <option value="" data-id="element-289">All Categories</option>
                <option value="Inborn" data-id="element-290">Inborn</option>
                <option value="Self-Reported" data-id="element-291">Self-Reported</option>
                <option value="Context" data-id="element-292">Context</option>
              </select>
            </div>
            <div className="flex space-x-2" data-id="element-293">
              <button className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7D56F4]" data-id="element-294">
                <DownloadIcon size={16} className="mr-2" data-id="element-295" />
                Export
              </button>
              <button onClick={() => {
              setEditingAssessment({
                id: '',
                name: '',
                category: 'Inborn',
                type: '',
                status: 'Active',
                apiSource: '',
                xpValue: 100,
                lastUpdated: new Date().toISOString().split('T')[0]
              });
              setIsModalOpen(true);
            }} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#7D56F4] hover:bg-[#6A46E5] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7D56F4]" data-id="element-296">
                <PlusIcon size={16} className="mr-2" data-id="element-297" />
                Add Assessment
              </button>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-298">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-299">
            <thead className="bg-gray-50" data-id="element-300">
              <tr data-id="element-301">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-302">
                  Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-303">
                  Category
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-304">
                  Input Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-305">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-306">
                  API Source
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-307">
                  XP Value
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-308">
                  Last Updated
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-309">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-310">
              {filteredAssessments.map(assessment => <tr key={assessment.id} data-id="element-311">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-312">
                    <div className="text-sm font-medium text-gray-900" data-id="element-313">
                      {assessment.name}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-314">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${assessment.category === 'Inborn' ? 'bg-purple-100 text-purple-800' : assessment.category === 'Self-Reported' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`} data-id="element-315">
                      {assessment.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-316">
                    {assessment.type}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-317">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${assessment.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-318">
                      {assessment.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-319">
                    <div className="flex items-center text-sm text-gray-500" data-id="element-320">
                      {assessment.apiSource}
                      {assessment.apiSource !== 'Internal' && <ExternalLinkIcon size={14} className="ml-1 text-gray-400" data-id="element-321" />}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-322">
                    {assessment.xpValue} XP
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-323">
                    {assessment.lastUpdated}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-324">
                    <button onClick={() => handleEditAssessment(assessment)} className="text-[#7D56F4] hover:text-[#6A46E5] mr-3" data-id="element-325">
                      <EditIcon size={16} data-id="element-326" />
                    </button>
                    <button className="text-red-500 hover:text-red-700" data-id="element-327">
                      <TrashIcon size={16} data-id="element-328" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-gray-200" data-id="element-329">
          <div className="flex justify-between items-center" data-id="element-330">
            <div className="text-sm text-gray-700" data-id="element-331">
              Showing{' '}
              <span className="font-medium" data-id="element-332">{filteredAssessments.length}</span>{' '}
              of <span className="font-medium" data-id="element-333">{assessments.length}</span>{' '}
              assessments
            </div>
          </div>
        </div>
      </div>
      {/* Edit/Add Assessment Modal */}
      {isModalOpen && <div className="fixed inset-0 overflow-y-auto z-50" data-id="element-334">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-335">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-id="element-336">
              <div className="absolute inset-0 bg-gray-500 opacity-75" data-id="element-337"></div>
            </div>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-338">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-339">
                <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4" data-id="element-340">
                  {editingAssessment?.id ? 'Edit Assessment' : 'Add New Assessment'}
                </h3>
                <div className="space-y-4" data-id="element-341">
                  <div data-id="element-342">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-343">
                      Assessment Name
                    </label>
                    <input type="text" id="name" value={editingAssessment?.name || ''} onChange={e => setEditingAssessment({
                  ...editingAssessment,
                  name: e.target.value
                })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-344" />
                  </div>
                  <div data-id="element-345">
                    <label htmlFor="category" className="block text-sm font-medium text-gray-700" data-id="element-346">
                      Category
                    </label>
                    <select id="category" value={editingAssessment?.category || ''} onChange={e => setEditingAssessment({
                  ...editingAssessment,
                  category: e.target.value
                })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-347">
                      <option value="Inborn" data-id="element-348">Inborn</option>
                      <option value="Self-Reported" data-id="element-349">Self-Reported</option>
                      <option value="Context" data-id="element-350">Context</option>
                    </select>
                  </div>
                  <div data-id="element-351">
                    <label htmlFor="type" className="block text-sm font-medium text-gray-700" data-id="element-352">
                      Input Type
                    </label>
                    <input type="text" id="type" value={editingAssessment?.type || ''} onChange={e => setEditingAssessment({
                  ...editingAssessment,
                  type: e.target.value
                })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-353" />
                  </div>
                  <div data-id="element-354">
                    <label htmlFor="status" className="block text-sm font-medium text-gray-700" data-id="element-355">
                      Status
                    </label>
                    <select id="status" value={editingAssessment?.status || ''} onChange={e => setEditingAssessment({
                  ...editingAssessment,
                  status: e.target.value
                })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-356">
                      <option value="Active" data-id="element-357">Active</option>
                      <option value="Inactive" data-id="element-358">Inactive</option>
                    </select>
                  </div>
                  <div data-id="element-359">
                    <label htmlFor="apiSource" className="block text-sm font-medium text-gray-700" data-id="element-360">
                      API Source
                    </label>
                    <input type="text" id="apiSource" value={editingAssessment?.apiSource || ''} onChange={e => setEditingAssessment({
                  ...editingAssessment,
                  apiSource: e.target.value
                })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-361" />
                  </div>
                  <div data-id="element-362">
                    <label htmlFor="xpValue" className="block text-sm font-medium text-gray-700" data-id="element-363">
                      XP Value
                    </label>
                    <input type="number" id="xpValue" value={editingAssessment?.xpValue || 0} onChange={e => setEditingAssessment({
                  ...editingAssessment,
                  xpValue: parseInt(e.target.value)
                })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-364" />
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-365">
                <button type="button" onClick={handleSaveAssessment} className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-[#7D56F4] text-base font-medium text-white hover:bg-[#6A46E5] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7D56F4] sm:ml-3 sm:w-auto sm:text-sm" data-id="element-366">
                  Save
                </button>
                <button type="button" onClick={() => setIsModalOpen(false)} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7D56F4] sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-367">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};